import React from "react";
import AreaAtuacaoService from "../../services/AreaAtuacaoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaAreaAtuacao extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: AreaAtuacaoService,
            labels: {
                title: 'Lista de Área de Atuação(ões)',
                btnNewRegister: 'Área de Atuação',
            },
            keyItem: 'idAreaAtuacao',
            urlForm: '/CadAreaAtuacao',
            itensFilter: ["idAreaAtuacao", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idAreaAtuacao}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}